import { Dialog, List, ListItemButton, ListItemText } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

@inject('commonStore', 'menuStore', 'cartStore')
@observer
class LanguageModal extends Component {
  /** 언어 변경 */
  handleLanguageClick = language => {
    this.props.i18n.changeLanguage(language);
    window.location.reload();
  };

  render() {
    const { commonStore, i18n, menuStore } = this.props;

    if (!commonStore.isLanguageDialogOpen) return null;
    return (
      <Dialog open={commonStore.isLanguageDialogOpen} onClose={() => commonStore.setLanguageDialogOpen(false)}>
        <List>
          <ListItemButton selected={i18n.language === 'en'} onClick={() => this.handleLanguageClick('en')}>
            <ListItemText primary="English" />
          </ListItemButton>
          <ListItemButton selected={i18n.language === 'ko'} onClick={() => this.handleLanguageClick('ko')}>
            <ListItemText primary="한국어" />
          </ListItemButton>
          <ListItemButton selected={i18n.language === 'zh'} onClick={() => this.handleLanguageClick('zh')}>
            <ListItemText primary="中文" />
          </ListItemButton>
          <ListItemButton selected={i18n.language === 'ja'} onClick={() => this.handleLanguageClick('ja')}>
            <ListItemText primary="日本語" />
          </ListItemButton>
          {menuStore.storeData.culture === 'th-TH' && (
            <ListItemButton selected={i18n.language === 'th'} onClick={() => this.handleLanguageClick('th')}>
              <ListItemText primary="ภาษาไทย" />
            </ListItemButton>
          )}
          {menuStore.storeData.culture === 'vi-VN' && (
            <ListItemButton selected={i18n.language === 'vi'} onClick={() => this.handleLanguageClick('vi')}>
              <ListItemText primary="Tiếng Việt" />
            </ListItemButton>
          )}
        </List>
      </Dialog>
    );
  }
}

export default withTranslation()(LanguageModal);
